import { ImageData } from '../../types';
import { getFilenameAndExtension } from '../file';

const IMAGE_FALLBACK = '1.jpg';
export const DEFAULT_IMAGE_QUALITY_PARAMETER = 85;

export const getImageSrc = (
  imageSrc: string,
  imagePresetsOfProductImage: [number, number][],
  sizeQueries: string[],
  assetsPath: string,
  imageTitle?: string,
  imageQuality: number = DEFAULT_IMAGE_QUALITY_PARAMETER,
): ImageData => {
  const [imagePath, extension] = getFilenameAndExtension(imageSrc || IMAGE_FALLBACK);

  const getSrcSet = (format = 'jpeg', quality = imageQuality): string[] =>
    imagePresetsOfProductImage.map(([w, h]) => {
      return `${assetsPath}${imagePath}-${w}x${h}.${extension}?quality=${quality}&format=${format} ${w}w`;
    });

  const src = getSrcSet()[0].split(' ')[0];
  const srcSetWebp = getSrcSet('webp');
  const [width, height] = imagePresetsOfProductImage[imagePresetsOfProductImage.length - 1];

  return {
    src,
    sizes: sizeQueries,
    srcSetWebp: srcSetWebp,
    alt: imageTitle,
    width,
    height,
  };
};
